import React, { ReactElement } from 'react'

import {
  SettingsRounded,
  NotificationsRounded,
  ListAltRounded,
  ImportContactsRounded,
  PersonRounded,
  BoltRounded,
  TrendingUpRounded,
} from '@mui/icons-material'
import { LoginScreen, MagicLinkScreen, WorkspaceScreen } from '../screens'
import { MagicLinkSentScreen } from '../screens/login/magic-link/magic-link-sent-screen'
import { SSOEntryScreen } from '../screens/login/sso-entry'
import { NotificationsScreen } from '../screens/notifications'
import { LibraryScreen } from '../screens/library'
import { TalkScreen } from '../screens/talk'
import { SettingsScreen } from '../screens/settings'
import { AltProfileScreen, ProfileScreen } from '../screens/profile'
import { MagicLinkErrorScreen } from '../screens/login/magic-link/magic-link-error-screen'
import { SignupScreen } from '../screens/login/signup-screen'
import { RouteProps } from 'react-router-dom'
import { PlayScreen } from '../screens/play/play-screen/play-screen'
import { TestLogin } from '../screens/test-login'

export type RouteType = {
  name: string
  path: string
  exact: boolean
  main: () => ReactElement<RouteProps>
}

export const liteRoutes = [
  {
    name: 'profile',
    label: 'Profile.header',
    path: '/profile/stats',
    exact: true,
    main: () => <ProfileScreen />,
    icon: (active?: boolean, isMobile?: boolean) => (
      <PersonRounded
        style={{
          fontSize: isMobile ? 28 : 24,
          marginRight: 16,
          color: active ? '#1B59F8' : 'rgba(0, 0, 0, .7)',
        }}
      />
    ),
  },
  {
    name: 'library',
    label: 'Library.header',
    path: '/library',
    exact: true,
    main: () => <LibraryScreen />,
    icon: (active?: boolean, isMobile?: boolean) => (
      <ImportContactsRounded
        style={{
          fontSize: isMobile ? 28 : 24,
          marginRight: 16,
          color: active ? '#1B59F8' : 'rgba(0, 0, 0, .7)',
        }}
      />
    ),
  },
  {
    name: 'notifications',
    label: 'Notifications.header',
    path: '/notifications',
    exact: true,
    main: () => <NotificationsScreen />,
    icon: (active?: boolean, isMobile?: boolean) => (
      <NotificationsRounded
        style={{
          fontSize: isMobile ? 28 : 24,
          marginRight: 16,
          color: active ? '#1B59F8' : 'rgba(0, 0, 0, .7)',
        }}
      />
    ),
  },
  {
    name: 'settings',
    label: 'Settings.header',
    path: '/settings',
    exact: true,
    main: () => <SettingsScreen />,
    icon: (active?: boolean, isMobile?: boolean) => (
      <SettingsRounded
        style={{
          fontSize: isMobile ? 28 : 24,
          marginRight: 16,
          color: active ? '#1B59F8' : 'rgba(0, 0, 0, .7)',
        }}
      />
    ),
  },
]

export const loginRoutes = [
  {
    name: 'login',
    path: '/login',
    exact: true,
    main: () => <LoginScreen />,
  },
  {
    name: 'test-login',
    path: '/test-login',
    exact: true,
    main: () => <TestLogin />,
  },
  {
    name: 'magic',
    path: '/login/magic',
    exact: true,
    main: () => <MagicLinkScreen />,
  },
  {
    name: 'sso',
    path: '/login/sso',
    exact: true,
    main: () => <SSOEntryScreen />,
  },
  {
    name: 'expired',
    path: '/login/expired',
    exact: true,
    main: () => <MagicLinkErrorScreen />,
  },
  {
    name: 'signup',
    path: '/signup',
    exact: true,
    main: () => <SignupScreen />,
  },
  {
    name: 'verify',
    path: '/login/magic/sent',
    exact: true,
    main: () => <MagicLinkSentScreen />,
  },
  {
    name: 'workspaces',
    path: '/workspaces',
    exact: true,
    main: () => <WorkspaceScreen />,
  },
]

export interface Route {
  name: string
  label: string
  path: string
  exact: boolean
  main: () => ReactElement
  icon: (active?: boolean) => ReactElement
}

export const authenticatedRoutes = () => {
  return [
    {
      name: 'dashboard',
      label: 'Dashboard.header',
      path: '/dashboard/stats',
      exact: true,
      main: () => <ProfileScreen dashboard />,
      icon: (active?: boolean, isMobile?: boolean) => (
        <TrendingUpRounded
          style={{
            fontSize: isMobile ? 28 : 24,
            marginRight: 16,
            color: active ? '#1B59F8' : 'rgba(0, 0, 0, .7)',
          }}
        />
      ),
    },
    {
      name: 'talk',
      label: 'Discuss.header',
      path: '/talk',
      exact: true,
      main: () => <TalkScreen />,
      icon: (active?: boolean, isMobile?: boolean) => (
        <ListAltRounded
          style={{
            fontSize: isMobile ? 28 : 24,
            marginRight: 16,
            color: active ? '#1B59F8' : 'rgba(0, 0, 0, .7)',
          }}
        />
      ),
    },
    {
      name: 'library',
      label: 'Library.header',
      path: '/library',
      exact: true,
      main: () => <LibraryScreen />,
      icon: (active?: boolean, isMobile?: boolean) => (
        <ImportContactsRounded
          style={{
            fontSize: isMobile ? 28 : 24,
            marginRight: 16,
            color: active ? '#1B59F8' : 'rgba(0, 0, 0, .7)',
          }}
        />
      ),
    },
    {
      name: 'play',
      label: 'Play.header',
      path: '/play',
      exact: true,
      main: () => <PlayScreen />,
      icon: (active?: boolean, isMobile?: boolean) => (
        <BoltRounded
          style={{
            fontSize: isMobile ? 28 : 24,
            marginRight: 16,
            color: active ? '#1B59F8' : 'rgba(0, 0, 0, .7)',
          }}
        />
      ),
    },
    {
      name: 'notifications',
      label: 'Notifications.header',
      path: '/notifications',
      exact: true,
      main: () => <NotificationsScreen />,
      icon: (active?: boolean, isMobile?: boolean) => (
        <NotificationsRounded
          style={{
            fontSize: isMobile ? 28 : 24,
            marginRight: 16,
            color: active ? '#1B59F8' : 'rgba(0, 0, 0, .7)',
          }}
        />
      ),
    },
    {
      name: 'profile',
      label: 'Profile.header',
      path: '/profile/stats',
      exact: true,
      main: () => <ProfileScreen />,
      icon: (active?: boolean, isMobile?: boolean) => (
        <PersonRounded
          style={{
            fontSize: isMobile ? 28 : 24,
            marginRight: 16,
            color: active ? '#1B59F8' : 'rgba(0, 0, 0, .7)',
          }}
        />
      ),
    },
    {
      name: 'settings',
      label: 'Settings.header',
      path: '/settings',
      exact: true,
      main: () => <SettingsScreen />,
      icon: (active?: boolean, isMobile?: boolean) => (
        <SettingsRounded
          style={{
            fontSize: isMobile ? 28 : 24,
            marginRight: 16,
            color: active ? '#1B59F8' : 'rgba(0, 0, 0, .7)',
          }}
        />
      ),
    },
    {
      name: 'profile-alt',
      label: 'Settings.header',
      path: '/settings',
      exact: true,
      main: () => <AltProfileScreen />,
      icon: (active?: boolean, isMobile?: boolean) => (
        <PersonRounded
          style={{
            fontSize: isMobile ? 28 : 24,
            marginRight: 16,
            color: active ? '#1B59F8' : 'rgba(0, 0, 0, .7)',
          }}
        />
      ),
    },
  ]
}
